module.exports = __webpack_public_path__ + "img/logo-bottom-grey.d1a23bad.png";